(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zinaty-hero-dual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zina-worlds')) {
  customElements.define('zina-worlds', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.zw-hero__slide')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggle = this.querySelector('[data-toggle]');
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateToggle();
        this.start();
      }, options);
      this.addEventListener('mouseenter', () => clearInterval(this.timer), options);
      this.addEventListener('mouseleave', () => this.start(), options);
      this.addEventListener('focusin', () => clearInterval(this.timer), options);
      this.addEventListener('focusout', () => this.start(), options);
      document.addEventListener('visibilitychange', () => this.start(), options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.show(index); this.updateToggle(); }
      }, options);
      this.updateToggle();
      this.start();
    }
    updateToggle() {
      this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.start();
    }
    start() {
      clearInterval(this.timer);
      if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) {
        this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.controller) this.controller.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
